import $ from 'jquery';
import 'select2';

window.initializeSelect2 = () => {
  $('.select2').select2({
    width: '100%',
  });

  // スタイルの調整
  $('.select2-selection--single').css('height', 'calc(1.5em + 0.75rem + 2px)');
  $('.select2').on('select2:open', function () {
    $('.select2-selection--single').css('height', 'calc(1.5em + 0.75rem + 2px)');
  });
};

const destroySelect2 = () => {
  $('.select2').each(function () {
    if ($(this).data('select2')) {
      $(this).select2('destroy');
    }
  });
};

document.addEventListener("turbolinks:load", window.initializeSelect2);
document.addEventListener("turbolinks:before-cache", destroySelect2);
